import { render, staticRenderFns } from "./header-tab.vue?vue&type=template&id=3c68d6d2&scoped=true&"
import script from "./header-tab.vue?vue&type=script&lang=ts&"
export * from "./header-tab.vue?vue&type=script&lang=ts&"
import style0 from "./header-tab.vue?vue&type=style&index=0&id=3c68d6d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c68d6d2",
  null
  
)

export default component.exports